import { defineComponent, computed, ref, nextTick } from "vue";
import IconButton from "../common/base/IconButton.vue.mjs";
import VirtualBackgroundIcon from "../common/icons/VirtualBackgroundIcon.vue.mjs";
import { useI18n } from "../../locales/index.mjs";
import "../../services/main.mjs";
import { roomService } from "../../services/roomService.mjs";
import "@tencentcloud/tuiroom-engine-js";
import "../../utils/environment.mjs";
import "mitt";
import "../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
import Dialog from "../common/base/Dialog/index.mjs";
import CloseVirtualBackground from "../../assets/imgs/close-virtual-background.png.mjs";
import BlurredBackground from "../../assets/imgs/blurred-background.png.mjs";
import TuiButton from "../common/base/Button.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "VirtualBackground",
  setup(__props) {
    const { t } = useI18n();
    const componentConfig = roomService.componentManager.getComponentConfig("VirtualBackground");
    const isAllowed = computed(
      () => {
        var _a;
        return (_a = roomService.roomStore.localStream) == null ? void 0 : _a.hasVideoStream;
      }
    );
    const appliedBackground = ref("close");
    const selectedBackground = ref("close");
    const isDialogVisible = ref(false);
    const isLoading = ref(false);
    const openSettingPanel = async () => {
      var _a;
      roomService.virtualBackground.initVirtualBackground();
      isDialogVisible.value = true;
      isLoading.value = true;
      await nextTick();
      await ((_a = roomService.roomEngine.instance) == null ? void 0 : _a.startCameraDeviceTest({
        view: "stream-preview"
      }));
      isLoading.value = false;
    };
    const closeSettingPanel = async () => {
      var _a;
      isDialogVisible.value = false;
      await applyVirtualBackground(appliedBackground.value);
      (_a = roomService.roomEngine.instance) == null ? void 0 : _a.stopCameraDeviceTest();
      selectedBackground.value = appliedBackground.value;
    };
    const confirmVirtualBackground = async () => {
      if (!isAllowed.value) return;
      appliedBackground.value = selectedBackground.value;
      closeSettingPanel();
      if (selectedBackground.value === "blur") {
        await roomService.virtualBackground.toggleVirtualBackground(true);
      }
      if (selectedBackground.value === "close") {
        await roomService.virtualBackground.toggleVirtualBackground(false);
      }
    };
    const applyVirtualBackground = async (type) => {
      isLoading.value = true;
      try {
        selectedBackground.value = type;
        await roomService.virtualBackground.toggleTestVirtualBackground(
          type === "blur"
        );
      } finally {
        isLoading.value = false;
      }
    };
    return { __sfc: true, t, componentConfig, isAllowed, appliedBackground, selectedBackground, isDialogVisible, isLoading, openSettingPanel, closeSettingPanel, confirmVirtualBackground, applyVirtualBackground, IconButton, VirtualBackgroundIcon, Dialog, CloseVirtualBackground, BlurredBackground, TuiButton };
  }
});
export {
  _sfc_main as default
};
